import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GenericService } from '../generic.service';
import { BasicDetailsResponse } from '../../models/Institutedetails/Basicdetailsresponse';
import { countryResponse } from '../../models/Institutedetails/Countryresponse';
import { StateRequest, StateResponse } from '../../models/Institutedetails/Stateresponse';
import { apiResponse } from '../../models/apiResponse';
import { Rankingrequest, Rankingresponse } from '../../models/Institutedetails/Rankingrequest';
import { InstituteCommonDetailsResponse } from '../../models/Institutedetails/InstituteCommonDetailsResponse';
import { CityRequest, CityResponse } from '../../models/Institutedetails/CityResponse';
import { Undergraduaterequest, Undergraduateresponse } from '../../models/Institutedetails/Undergraduaterequest';
import { Mastersrequest, Mastersresponse } from '../../models/Institutedetails/Mastersrequest';
import { Coursedetails, CourseResponse, GetCourse, GetCourseResponse } from '../../models/Institutedetails/Coursedetails';
import { CourseLevelEnum } from '../../models/enums/courseLevelEnum';

@Injectable({
    providedIn: 'root'
})
export class AddInstituteService {

    constructor(private genericService: GenericService) { }

    basicdetails(request: any): Observable<apiResponse<BasicDetailsResponse>> {
        return this.genericService.post(`instituecommondetails`, request);
    }
    updateBasicDetails(id: string, request: any): Observable<apiResponse<BasicDetailsResponse>> {
        return this.genericService.put(`instituecommondetails/${id}`, request);
    }

    getCountry(): Observable<apiResponse<countryResponse[]>> {
        return this.genericService.get(`country`);
    }

    getProvinces(countrycode: string): Observable<apiResponse<StateResponse[]>> {
        return this.genericService.get(`states/${countrycode}`)
    }

    getCity(provinceId: number): Observable<apiResponse<CityResponse[]>> {
        return this.genericService.get(`city/${provinceId}`);
    }

    addProvince(request: StateRequest): Observable<apiResponse<StateResponse>> {
        return this.genericService.post(`states`, request);
    }

    addCity(request: CityRequest): Observable<apiResponse<CityResponse>> {
        return this.genericService.post(`city`, request);
    }

    rankingdetails(request: Rankingrequest): Observable<apiResponse<Rankingresponse>> {
        return this.genericService.post(`instituterankings`, request);
    }

    updateRankingDetails(request: Rankingrequest): Observable<apiResponse<Rankingresponse>> {
    return this.genericService.put(`instituterankings`, request);
}
    // getRankingDetails(id: string): Observable<apiResponse<Rankingresponse>> {
    //     return this.genericService.get(`v2/institute/rankings/${id}`);
    // }

    updateRankings(request: Rankingrequest): Observable<Rankingrequest> {
        return this.genericService.put(`instituterankings`, request);
    }

    getInstituteCommonDetails(id: string): Observable<apiResponse<InstituteCommonDetailsResponse>> {
        return this.genericService.get(`v2/institute/commondetails/${id}`);
    }

    checkInstituteNameExists(name: string, excludeInstituteId?: string): Observable<boolean> {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            return of(false);
        }
        return this.genericService
            .post<{ exists: boolean }>('institutes/name/exists', {
                InstituteName: trimmed,
                ExcludeInstituteId: excludeInstituteId || undefined
            })
            .pipe(
                map((res: any) => res?.exists === true || res?.result?.exists === true),
                catchError(() => of(false))
            );
    }

    undergraduatedetails(request: Undergraduaterequest): Observable<apiResponse<Undergraduateresponse>> {
        return this.genericService.post(`instituteundergraduatedetails`, request);
    }

    updateUndergraduateDetails(request: Undergraduaterequest): Observable<apiResponse<Undergraduateresponse>> {
        return this.genericService.put(`instituteundergraduatedetails`, request);
    }

    getUndergraduateDetails(id: string): Observable<apiResponse<Undergraduateresponse>> {
        return this.genericService.get(`v2/institute/undergraduate/${id}`);
    }

    mastersDetails(request: Mastersrequest): Observable<apiResponse<Mastersresponse>> {
        return this.genericService.post(`institutemastersdetails`, request);
    }

    updateMastersDetails(request: Mastersrequest): Observable<apiResponse<Mastersresponse>> {
        return this.genericService.put(`institutemastersdetails`, request);
    }

    getMastersDetails(id: string): Observable<apiResponse<Mastersresponse>> {
        return this.genericService.get(`v2/institute/masters/${id}`);
    }

    courseDetails(request: Coursedetails): Observable<apiResponse<CourseResponse>> {
        return this.genericService.post(`institutecoursedetails`, request);
    }

    updateCourseDetails(request: Coursedetails, courseid: string): Observable<apiResponse<CourseResponse>> {
        return this.genericService.put(`institutecoursedetails/${courseid}`, request);
    }

    deleteCourseDetails(courseid: string): Observable<apiResponse<CourseResponse>> {
        return this.genericService.delete(`institutecoursedetails/${courseid}`);
    }

    getcourseDetails(request: GetCourse): Observable<apiResponse<GetCourseResponse>> {
        return this.genericService.post(`v2/institutes/institute/courses`, request);
    }

    checkCourseNameExists(instituteId: string, courseName: string, courseLevel: CourseLevelEnum, excludeCourseId?: number): Observable<boolean> {
        const trimmed = (courseName || '').trim();
        if (!trimmed || !instituteId) {
            return of(false);
        }
        return this.genericService
            .post<{ exists: boolean }>(`institutes/course/exists`, {
                InstituteId: instituteId,
                CourseName: trimmed,
                ExcludeCourseId: excludeCourseId,
                CourseLevel: courseLevel
            })
            .pipe(
                map((res: any) => res?.exists === true || res?.result?.exists === true),
                catchError(() => of(false))
            );
    }
}
